import {
  CHANGE_ESIM_TO_SIM,
  CHANGE_ESIM_TO_SIM_ERROR,
  CLEAN_CHANGE_ESIM_TO_SIM,
  CLEAN_CHANGE_ESIM_TO_SIM_ERROR,
} from '_models/redux/types';

const initialState = {
  loaded: undefined,
  method: undefined,
  payload: undefined,
  status: undefined,
  state: undefined,
};

export default function changeEsimToSimReducer(state = initialState, action) {
  switch (action.type) {
    case CHANGE_ESIM_TO_SIM:
      return {
        ...state,
        loaded: true,
        method: action?.method || null,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'success',
      };

    case CHANGE_ESIM_TO_SIM_ERROR:
      return {
        ...state,
        loaded: true,
        method: action?.method || null,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'error',
      };

    case CLEAN_CHANGE_ESIM_TO_SIM:
      return {
        ...state,
        loaded: false,
        method: undefined,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'success-clean',
      };

    case CLEAN_CHANGE_ESIM_TO_SIM_ERROR:
      return {
        ...state,
        loaded: false,
        method: undefined,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'error-clean',
      };
    default:
      return state;
  }
}
